<button mat-icon-button 
        class="like-button" 
        [class.liked]="isLiked()" 
        (click)="toggleLike($event)"
        [class.light-theme]="theme() === 'light'"
        [disabled]="isPending()"> 
  <mat-icon>
    {{ isLiked() ? 'favorite' : 'favorite' }}
  </mat-icon>
</button>